import * as THREE from "three";

export function makeLetterTexture(
  letter: string,
  renderer: THREE.WebGLRenderer,
  size = 512,
) {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;

  const context = canvas.getContext("2d");
  if (!context) return null;

  context.clearRect(0, 0, size, size);
  context.fillStyle = "#171713";
  context.font = `900 ${(size * 310) / 512}px Arial, Helvetica, sans-serif`;
  context.textAlign = "center";
  context.textBaseline = "middle";
  context.fillText(letter, size / 2, (size * 270) / 512);

  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.anisotropy = renderer.capabilities.getMaxAnisotropy();
  return texture;
}
